import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { CountryManagementService } from '../../../service/country-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, KeyValues5, LastUsedSettingsType, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { MessageComponent } from '../message/message.component';
import { WhitelistConfigComponent } from '../whitelist-config/whitelist-config.component';
import { environment } from './../../../environments/environment';
import { WsUserService } from 'src/service/ws/ws-user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('content_login')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  isOpenCreateAccount = false;

  lstSectionConfigKeys: string[] = ["login"];
  txtPassword: string = ''; isShowPassword: boolean = false; showPasswordDisappearSeconds = 0; interval;
  selectedCountryId = ''; phoneNumber: string = ''; selectedContact: KeyValues5;
  message: string = ''; isRedAlert: boolean = true;
  elementIds: any = {
    ph_num: 'ph_num',
    pwd: 'login_pwd',
    country: 'login_country'
  };
  isVerificationPart: boolean = false; isPopupOpened: boolean = false;
  isRequeCheckInitiated = false;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, public countryManagementService: CountryManagementService, public profileManagementService: ProfileManagementService, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private modalService: NgbModal, private wsUserService: WsUserService) { }

  ngOnInit(): void {
    this.onCheckReques();
  }

  onCheckReques() {
    if (!this.isRequeCheckInitiated) {
      this.isRequeCheckInitiated = true;
      if (!this.localService.reques) {
        this.configurationManagementService.getReques().subscribe(result => {
          if (result && result.status == Status.Success) {
            this.localService.reques = this.localService.decryptCrypto(result.value, environment.ui);
            this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
          }
        });
      }
    }
  }

  ngOnChanges(): void {
    setTimeout(() => { //To avoid NG0100 error
      if (this.isOpenPopup) {
        this.onInitiate();
        this.offcanvasService.open(this.content, {
          position: 'end',
          backdrop: 'static',
          keyboard: false,
          animation: true,
          panelClass: 'popup_overlay_right',
          beforeDismiss: this.onBeforeDismiss
        });
      }
    }, 0);
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onInitiate() {
    this.message = '';
    this.isVerificationPart = false;
    this.txtPassword = '';
    this.selectedCountryId = this.localService.getLastUsedSetting(LastUsedSettingsType.CountryId);
    this.phoneNumber = this.localService.loginWithCountryAndPhoneNumber ?? this.localService.getLastUsedSetting(LastUsedSettingsType.PhoneNumber);
    if (this.localService.loginWithCountryAndPhoneNumber) {
      this.localService.loginWithCountryAndPhoneNumber = '';
      this.onForgotPwd();
    }
    setTimeout(() => {
      this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox);
      this.onAutoLogin();
    }, environment.is_whitelist_enabled ? 200 : 0);
    this.startTimer();
  }

  onAutoLogin() {
    let lastUser = this.localService.getLastUser();
    if (lastUser && lastUser.key && lastUser.isSelected) {
      this.onLogin(true);
    }
  }

  onCreateAccountClick() {
    this.isPopupOpened = true;
    this.localService.onShowHideOverLayPopup(false);
    this.isOpenCreateAccount = true;
    this.onCloseTrigger();
  }

  onCloseCreateAccount(result) {
    if (result) {
      this.isPopupOpened = false;
      this.localService.onShowHideOverLayPopup(true);
      if (result.event == TriggeredEvent.Ok) {
        this.phoneNumber = result.data;
        this.selectedCountryId = this.localService.countryCodes.find(x => x.v2 == result.ctryCode).key;
        this.phoneNumber = result.phoneNumber;
        this.selectedContact.isReadonly = true;
        if (result.status == Status.NotAllowed) {
          this.localService.showInformation(this.localService.languageContent.login.not_in_whitelist);
          this.onOpenWhiteList();
        } else {
          this.isVerificationPart = true;
        }
      }
    } else {
      this.isPopupOpened = false;
      this.localService.onShowHideOverLayPopup(true);
    }
  }

  onContactUpdated(e) {
    this.selectedContact = e;
    this.localService.selected.countryCode = this.selectedContact.v2;
    this.phoneNumber = this.selectedContact.v5;
    if (this.selectedContact.isReadonly) {
      setTimeout(() => {
        this.localService.onFocusNextInput(this.elementIds.pwd, FocusInputType.TextBox);
      }, environment.is_whitelist_enabled ? 200 : 0);
    }
  }

  onOpenWhiteList() {
    this.isPopupOpened = true;
    this.localService.onShowHideOverLayPopup(false);
    const modalRef = this.modalService.open(WhitelistConfigComponent);
    modalRef.componentInstance.ctryCode = this.selectedContact.v2;
    modalRef.componentInstance.phoneNumber = this.phoneNumber;
    modalRef.result.then((result) => {
      this.isPopupOpened = false;
      this.localService.onShowHideOverLayPopup(true);
      if (result.event == TriggeredEvent.Ok) {
        this.selectedCountryId = result.data.key;
        this.phoneNumber = result.data.v5;
        this.localService.showInformation(this.localService.languageContent.login.whitelist_requested);
      }
    }, (error) => {
      this.isPopupOpened = false;
      this.localService.onShowHideOverLayPopup(true);
    });
  }

  onLogin(isAutoLogin = false) {
    if (isAutoLogin || this.doCheck()) {
      this.profileManagementService.getLoggedMember(this.phoneNumber, isAutoLogin ? environment.usr_pwd : this.txtPassword).subscribe(result => {
        if (result.pwdStatus == Status.Success && result.memberStatus == Status.Success) {
          //console.log(result);
          this.localService.setLoggedMember(result);
          this.localService.onRefreshBusiness();
          this.localService.setLastUser();
          //this.onGetLoggedMember();
          this.setMenuHidden();
          this.onCloseTrigger({ event: TriggeredEvent.Ok });
        } else if (result.pwdStatus == Status.ResetPwd) {
          this.onForgotPwd();
        } else if (result.memberStatus == Status.Blocked) {
          this.message = this.localService.languageContent.login.user_blocked;
        } else if (result.memberStatus == Status.NotAllowed) {
          this.localService.showInformation(this.localService.languageContent.login.not_in_whitelist);
          this.onOpenWhiteList();
        } else if (result.memberStatus == Status.UnAvailable) {
          this.message = this.localService.languageContent.login.user_unavailable;
        } else if (result.memberStatus == Status.DataRequired) {
          this.message = this.localService.languageContent.login.need_pwd;
          this.localService.onFocusNextInput(this.elementIds.pwd, FocusInputType.TextBox);
        } else if (result.pwdStatus == Status.Invalid) {
          this.message = this.localService.languageContent.login.invalid_pwd;
        } else if (result.pwdStatus == Status.NeedOtpVerification) {
          this.isVerificationPart = true;
        }
      });
    }
    return false;
  }

  onGetLoggedMember() {
    this.profileManagementService.getLoggedMember(this.phoneNumber, this.txtPassword).subscribe(result => {
      if (result.pwdStatus == Status.Success && result.memberStatus == Status.Success) {
        this.localService.setLoggedMember(result);
        this.localService.onRefreshBusiness();
        this.localService.setLastUser();
        this.onCloseTrigger({ event: TriggeredEvent.Ok });
      }
    });
  }

  onForgotPwd() {
    if (this.doCheck(false)) {
      this.isVerificationPart = true;
    }
  }

  doCheck(isIncludePwd = true) {
    let message = '';
    this.txtPassword = this.txtPassword.trim();
    if (!this.phoneNumber) {
      message = this.localService.languageContent.login.need_ph_num;
      this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox);
    } else if (!this.selectedContact.isReadonly) {
      message = this.localService.languageContent.login.ph_num_invalid_digit;
      this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox);
    } //else if (isIncludePwd && this.txtPassword == '') {
    //  message = this.localService.languageContent.login.need_pwd;
    //  this.localService.onFocusNextInput(this.elementIds.pwd, FocusInputType.TextBox);
    //}
    this.message = message;
    return message == '';
  }

  onFocus() {
    if (!this.phoneNumber) {
      this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox);
    } else if (!this.txtPassword) {
      this.localService.onFocusNextInput(this.elementIds.pwd, FocusInputType.TextBox);
    }
  }

  onPwdChanged($event) {
    this.txtPassword = $event;
    this.onLogin();
  }

  onNotAllowed() {
    this.isVerificationPart = false;
    this.localService.showInformation(this.localService.languageContent.login.not_in_whitelist);
    this.onOpenWhiteList();
  }

  onBlocked() {
    this.isVerificationPart = false;
    this.message = this.localService.languageContent.login.user_blocked;
  }

  onNew() {
    this.isVerificationPart = false;
    this.onCreateAccountClick();
  }

  setMenuHidden() {
    if (this.localService.loggedMember) {
      this.localService.hiddenMenu = [];
      this.localService.loggedMember.allowedMenus.find(x => x.businessId == this.localService.getSelectedBusinessId())?.menus.forEach(menu => {
        if (menu && menu.subMenus) {
          menu.subMenus.forEach(subMenu => {
            if (!subMenu.menu.isSelected) {
              this.localService.hiddenMenu.push(subMenu.menu.key);
            }
          });
        }
      });
      this.localService.setMenuHidden();
    }
  }

  onShowHidePassword() {
    this.isShowPassword = !this.isShowPassword;
    this.showPasswordDisappearSeconds = this.isShowPassword ? 10 : 0;
    this.localService.onFocusNextInput(this.elementIds.pwd, FocusInputType.TextBox);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  startTimer() {
    this.interval = setInterval(() => {
      this.showPasswordDisappearSeconds--;
      if (this.showPasswordDisappearSeconds <= 0) {
        this.isShowPassword = false;
      }
    }, 1000);
  }
}
